import React from 'react'
import LayerWithProgress from 'shared/components/LayerWithProgress/index'

const withProgress = (WrappedComponent) => {
    return class extends React.Component {
        render() {
            const {loading, loadingText, ...passThroughProps} = this.props
            return (
                <div style={{position: 'relative'}}>
                    <WrappedComponent {...passThroughProps}/>
                    {loading &&
                        <LayerWithProgress loadingText={loadingText || 'Loading...'}/>}
                </div>
            )
        }
    }
}

export default withProgress




// WEBPACK FOOTER //
// ./src/shared/hoc/progress/index.js